import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaMoon, FaSun, FaTimes } from "react-icons/fa";
import { SiteLogo } from "../SiteLogo";
import { NavMenuItems } from "./ComponentItems";
import { useTheme } from "../../theme";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  return (
    <nav className="sticky top-0 z-50 border-b border-line/20 bg-bg/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <SiteLogo onClick={() => setOpen(false)} />

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-line/30 text-ink transition hover:border-accent hover:bg-accent/10 hover:text-accent"
          >
            {theme === "dark" ? <FaSun /> : <FaMoon />}
          </button>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-line/30 text-ink md:hidden"
            aria-label="Toggle menu"
          >
            {open ? <FaTimes /> : <FaBars />}
          </button>

          <div
            className={`
              absolute left-0 right-0 top-16 border-b border-line/20 bg-bg/95 p-4 backdrop-blur-md md:static md:border-0 md:bg-transparent md:p-0 md:backdrop-blur-none
              ${open ? "block" : "hidden"} md:block
            `}
          >
            <div className="flex flex-col gap-1 md:flex-row md:items-center md:gap-1">
              {NavMenuItems.map((item) => (
                <NavLink
                  key={item.url}
                  to={item.url}
                  end={item.url === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    [
                      "rounded-lg px-3 py-2 text-sm font-medium transition",
                      isActive
                        ? "bg-accent/15 text-accent"
                        : "text-muted hover:bg-accent/10 hover:text-ink",
                    ].join(" ")
                  }
                >
                  {item.title}
                </NavLink>
              ))}
              <a
                href="https://forms.gle/NSWD778xKKMRyY3TA"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 btn-primary !px-4 !py-2 text-sm md:ml-2 md:mt-0"
                onClick={() => setOpen(false)}
              >
                Sign up for updates
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};
